/**
 * Confirmation dialog component.
 *
 * Replaces the legacy bootbox.confirm() calls used throughout the AngularJS app.
 * Presents a modal with a message and Confirm/Cancel buttons.
 */
import Modal from './Modal';

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  /** Button to focus when the dialog opens. Unset: focus is left where it is. */
  initialFocus?: 'confirm' | 'cancel';
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDialog({
  open,
  title = 'Confirm',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  initialFocus,
  onConfirm,
  onCancel,
}: Readonly<ConfirmDialogProps>) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      size="sm"
      footer={
        <>
          <button
            className="aurora-btn"
            onClick={onCancel}
            autoFocus={initialFocus === 'cancel'} // NOSONAR typescript:S9379 accessibility-by-design: dialog autoFocus (primary control focused on open)
          >
            {cancelLabel}
          </button>
          <button
            className={danger ? 'aurora-btn aurora-btn-danger' : 'aurora-btn aurora-btn-primary'}
            onClick={onConfirm}
            autoFocus={initialFocus === 'confirm'} // NOSONAR typescript:S9379 accessibility-by-design: dialog autoFocus (primary control focused on open)
          >
            {confirmLabel}
          </button>
        </>
      }
    >
      <p className="text-sm text-aurora-text/85" >{message}</p>
    </Modal>
  );
}
